const PrivacyEn = () => {
  return (
    <div className="py-12 text-gray-600">
      <div className="max-w-3xl mx-auto px-4 space-y-8">
        <h1 className="text-3xl font-bold">[Privacy Policy]</h1>

        <p>
          When you use &#39;She App,&#39; you entrust Philmedi Co., Ltd. with
          personal information related to you.
        </p>

        <p>
          We have established regulations to protect users&#39; data and privacy
          rights. We take all necessary measures to safeguard the information
          you entrust to us and provide transparency in our data management
          practices.
        </p>

        <p>
          Additionally, we collect, use, and share users&#39; personal
          information with third parties in accordance with state and local
          regulations of the Personal Information Protection Act, solely for the
          purpose of improving She App and enhancing user convenience. The scope
          of personal information collection is as follows:
        </p>

        <p>
          1. Items: Name, Gender, Date of Birth, Phone Number, Email, Service
          and App Usage History
          <br />
          2. Collection Method: She App and bibliography
          <br />
          3. Retention Period: 1 year from the date consent form completed
          <br />
          4. Retention Basis: Service provision
          <br />
          5. Subjects of Retention: Those who consent to provide personal
          information and are over the age of 14
        </p>

        <p>
          Philmedi&#39;s personal information collection policy is effective
          from February 1, 2022, and remains valid until the consent-based
          retention period expires.
          <br />
          Subjects of personal information have the following rights:
        </p>

        <p>
          1. Request to access personal information
          <br />
          2. Request to modify personal information
          <br />
          3. Request to delete personal information
          <br />
          4. Request for processing personal information
        </p>

        <p>
          The exercise of these rights can be done in writing, by mail, or by
          fax, in accordance with the enforcement rules of the Personal
          Information Protection Act. Requests can be made directly by the
          subject of the information or through a legal representative. Philmedi
          is obliged to take immediate action upon receiving such requests.
        </p>

        <p>
          Please read all the details thoroughly and decide whether you agree or
          not.
        </p>

        <p>□ Offshore retention of personal information</p>

        <p>
          Philmedi Co., Ltd. stores the data collected, generated, and analyzed
          by the subject of information in databases maintained by Google and
          Amazon.
        </p>

        <p>
          In principle, these databases do not search, modify, or delete
          personal information related to the subject.
        </p>

        <p>
          The retention of personal information in database continues until the
          withdrawal of the subject of information and the end of the service
          along with the consignment contract.
        </p>

        <p>
          The management and use of the database are entrusted to a third-party
          provider.
        </p>

        <p>
          <br />□ The collection of personal information, its purpose and
          retention period
        </p>

        <p>
          &nbsp;※ You have the right to refuse the collection and use of the
          personal information above.
          <br />
          &nbsp; &nbsp;However, if you refuse to accept, you will not be able to
          use the app.
        </p>

        <p>
          □ The process of sensitive information, its purpose and retention
          period
        </p>

        <p>
          &nbsp;※ You have the right to refuse the collection and use of the
          personal information above.
          <br />
          &nbsp; &nbsp;However, if you refuse to accept, you will not be able to
          use the app.
        </p>

        <p>
          □ The provision of personal information to third parties, its purpose
          and retention period
        </p>

        <p>
          ※ You have the right to refuse the collection and use of the personal
          information above.
          <br />
          &nbsp; &nbsp;However, if you refuse to accept, you will not be able to
          use the app.
        </p>
      </div>
    </div>
  );
};

export default PrivacyEn;
